import { render, staticRenderFns } from "./Lightbox.vue?vue&type=template&id=145d7e82&scoped=true"
import script from "./Lightbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./Lightbox.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145d7e82",
  null
  
)

export default component.exports